/**
 * Global API Response Interceptor
 * 
 * Intercepts both Axios and native fetch() requests:
 * If the backend returns a 403 with code === "MUST_CHANGE_PASSWORD",
 * immediately updates local storage and redirects the user to /change-password.
 */

let isFetchPatched = false;

export function setupApiInterceptors() {
  if (typeof window === "undefined") return;

  if (!isFetchPatched && window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = async (resource, init = {}) => {
      const token = localStorage.getItem("token");
      let nextInit = { ...init };

      if (token) {
        if (nextInit.headers instanceof Headers) {
          if (!nextInit.headers.has("Authorization")) {
            nextInit.headers.set("Authorization", `Bearer ${token}`);
          }
        } else if (Array.isArray(nextInit.headers)) {
          const hasAuth = nextInit.headers.some(([k]) => String(k).toLowerCase() === "authorization");
          if (!hasAuth) {
            nextInit.headers = [...nextInit.headers, ["Authorization", `Bearer ${token}`]];
          }
        } else {
          nextInit.headers = {
            ...(nextInit.headers || {}),
          };
          if (!nextInit.headers.Authorization && !nextInit.headers.authorization) {
            nextInit.headers.Authorization = `Bearer ${token}`;
          }
        }
      }

      const response = await originalFetch(resource, nextInit);
      try {
        if (response.status === 403) {
          const clone = response.clone();
          clone
            .json()
            .then((data) => {
              if (data && data.code === "MUST_CHANGE_PASSWORD") {
                localStorage.setItem("mustChangePassword", "true");
                if (window.location.pathname !== "/change-password") {
                  window.location.replace("/change-password");
                }
              }
            })
            .catch(() => {});
        }
      } catch (e) {
        // Pass through quietly on stream read issues
      }
      return response;
    };
    isFetchPatched = true;
  }
}
